import { omit } from "lodash-es";
import type { FC } from "react";
import { SendTestButton } from "../../send-test/send-test-button";
import { SendTestGuidance } from "../../send-test/send-test-guidance";
import type { SaveButtonProps } from "../../types";

export const PreviewSendTestButton: FC<Omit<SaveButtonProps, "employeeCountState">> = (props) => {
  return (
    <SendTestButton {...omit(props, "isNewsletter")} sx={{ ml: 0 }}>
      <SendTestGuidance />
    </SendTestButton>
  );
};
